import './ConnectionInfo.scss';

import { FC, useState } from 'react';
import { Connection } from 'models/Connection';
import { ConnectionStatus } from 'models/ConnectionStatus';
import { Button, Modal } from 'react-bootstrap';

interface ConnectionInfoProps {
  connectionInfo?: Connection,
  customActionName?: string,
  customAction?: (connection: Connection) => Promise<boolean>,
}

const ConnectionInfo: FC<ConnectionInfoProps> = ({connectionInfo, customActionName, customAction}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (!connectionInfo) {
    return (<>&nbsp;</>);
  }
  
  return (
    <div className="ConnectionInfo">
      {connectionInfo.connectionStatus === ConnectionStatus.OK ? 
      "OK" : 
      <>
        <button type='button' className='btn btn-danger' onClick={handleShow}>Error</button>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Error Message Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p>Error Code: {connectionInfo.connectionErrorCode}</p>
              <p>Message: {connectionInfo.connectionErrorReason}</p>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>Okay</Button>
              {customActionName && customAction ?
                <Button variant='primary' onClick={async () => { const isSuccessful = await customAction(connectionInfo); if (isSuccessful) handleClose(); }}>{customActionName}</Button> :
                ""
              }
            </Modal.Footer>
        </Modal>
      </>
      }
    </div>
  );
}

export default ConnectionInfo;
